import { render, staticRenderFns } from "./CoTwoProductionControlRoomForm.vue?vue&type=template&id=51a75522&scoped=true&"
import script from "./CoTwoProductionControlRoomForm.vue?vue&type=script&lang=js&"
export * from "./CoTwoProductionControlRoomForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a75522",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51a75522')) {
      api.createRecord('51a75522', component.options)
    } else {
      api.reload('51a75522', component.options)
    }
    module.hot.accept("./CoTwoProductionControlRoomForm.vue?vue&type=template&id=51a75522&scoped=true&", function () {
      api.rerender('51a75522', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/carbonclap/components/green/form/CoTwoProductionControlRoomForm.vue"
export default component.exports